import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // anchorScrolling intentionally disabled: NavigationService.goToQuoteForm owns
    // the scroll sequence so it can close the mobile overlay and wait for layout
    // to settle before measuring. With anchorScrolling enabled, Angular fires a
    // second scroll against the section's scroll-margin-top and races our math.
    // 'enabled': new pages open at the top; Back/Forward return to the saved position
    // (MV-390, was 'top'). ScrollRestorationService finishes the restore on pages
    // whose content arrives after the first render.
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient()
  ]
};
